import { Fragment, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AdressNavigation } from "../../StateManagment/AdressNavigation";
import uuid from "react-uuid";
import firebase from "../../firebase/compat";
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import { client } from "../../hooks/Client.js"
import { useFirestoreOrderBy, useFirestoreGeneralIn, useFirestoreGeneral, useFirestoreQuery } from "../../firebase/useFirestore.js";
import ScrollToTop from "../../hooks/ScrollToTop.js";
import Tooltip from "../../components/common/Tooltip.jsx";
import { Auth } from '../../StateManagment/Auth.js';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { db, timestamp } from "../../firebase/config.js"
import { SavedIcon } from "../../StateManagment/SavedIcon.js";
import DeleteModal from "../../components/common/DeleteModal.jsx";
import PageHeader from "../../components/layout/PageHeader.jsx";
import SelectableGrid from "../../components/common/SelectableGrid";
import Table from "../../components/common/table/Table.jsx";
import TableCell from "../../components/common/table/TableCell.jsx";
import TableDragHandleCell from "../../components/common/table/TableDragHandleCell.jsx";
import TableTitleCell from "../../components/common/table/TableTitleCell.jsx";
import ReadOnlyGuard from "../../components/common/ReadOnlyGuard";
import ToggleButton from "../../components/common/ToggleButton";
import { isSelfPickup } from "../../helpers/adressHelpers/selfPickup";
import { filterByLocation, buildLocationByAdressId, sortLocations, LOCATION_KEY } from "../../helpers/locations/locationFilter";
import hasLocationFilter from "../../helpers/dashboardHelpers/hasLocationFilter";
import MultiSelect from "../../components/common/MultiSelect";
import notDeleted from "../../helpers/notDeleted.js";
import softDeleteAdress from "../../helpers/adressHelpers/softDeleteAdress.js";
import AdressStatusSelect from "../../components/adresses/AdressStatusSelect.jsx";
import recordStatusChange from "../../helpers/statusHistory/recordStatusChange.js";
import { ADRESS_STATUS_KEYS } from "../../helpers/adressHelpers/adressStatusLabels.js";
import useSettings from "../../hooks/Settings.jsx";
import { statusDisplaysFrom } from "../../hooks/useStatusDisplay";
import useAdressStatusById from "../../hooks/useAdressStatusById";
import resolveHouseholdColumns from "../../helpers/adressHelpers/resolveHouseholdColumns";
import buildStatusTabs, { countByStatus } from "../../helpers/statusConfig/buildStatusTabs";
import resolveBoardView, { AGENDA_VIEW, BOARD_VIEW, TABLE_VIEW, boardViewSearch, householdPlanningEnabled } from "../../helpers/board/resolveBoardView";
import groupItemsByStatus from "../../helpers/board/groupItemsByStatus";
import StatusBoard from "../../components/common/board/StatusBoard.jsx";
import ViewSwitch from "../../components/common/ViewSwitch.jsx";
import HouseholdBoardCard from "../../components/adresses/HouseholdBoardCard.jsx";
import HouseholdAgendaView from "../../components/adresses/HouseholdAgendaView.jsx";
import { buildStreetLabelMap, nameLabel, householdLabel } from "../../helpers/adressHelpers/buildStreetLabels.js";
import { buildHouseholdSearchIndex, householdSearchText, findHouseholdSearchHit, fixedFieldSearchText } from "../../helpers/adressHelpers/householdSearch.js";
import { fixedFieldForTitle, formatHouseholdField, LABEL_LEGACY_TITLES } from "../../helpers/adressHelpers/householdFields.js";
import HouseholdSearchHit from "../../components/adresses/HouseholdSearchHit.jsx";
import useSharedCollection from "../../firebase/useSharedCollection.js";
import useSharedCollectionWhere from "../../firebase/useSharedCollectionWhere.js";
import { APPOINTMENT_TYPE, SUBTASK_TYPE } from "../../helpers/adressHelpers/taskKind.js";
import latestContactPerAdress from "../../helpers/adressHelpers/latestContactPerAdress.js";
import nextVisitPerAdress from "../../helpers/adressHelpers/nextVisitPerAdress.js";
import planningQueue, { planningQueueCount } from "../../helpers/adressHelpers/planningQueue.js";
import { isStarred, filterStarred, starredPatch } from "../../helpers/starred/starred.js";
import { labelsOf, hasLabel, labelPatch } from "../../helpers/adressHelpers/resolveAdressLabels.js";
import resolveWervingsDiensten, { dienstKeuzes, dienstNamen as toDienstNamen, dienstenOf } from "../../helpers/wervingsacties/resolveWervingsDiensten.js";
import StarToggle from "../../components/common/StarToggle.jsx";
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import openTasksPerAdress from "../../helpers/adressHelpers/openTasksPerAdress.js";
import notesPerAdress from "../../helpers/adressHelpers/notesPerAdress.js";
import { OUTCOME_LABELS } from "../../components/adresses/contactMoments/contactMomentLabels.js";
import { daysSince } from "../../utils/activityAge.js";
import ExportBar from "../../components/common/ExportBar.jsx";
import downloadDatedExport from "../../helpers/export/downloadDatedExport.js";
import filterExportRows from "../../helpers/export/filterExportRows.js";
import buildHouseholdExportRows from "../../helpers/export/buildHouseholdExportRows.js";
import AddressMatchesNotice from "../../components/adresses/AddressMatchesNotice.jsx";

// Derived from the canonical status list so a new status is filterable the
// moment it exists. The dashboard status chart deep-links here with
// `?status=<id>`, and an id missing from this list silently falls back to
// 'Inplannen' — which is how 'unreachable' used to be unreachable.
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
const VALID_STATUSES = [...ADRESS_STATUS_KEYS, 'all']

// Sorteren op status volgt de trechter, niet het alfabet — anders begint de
// lijst bij 'Afgerond'. Onbekende waarden krijgen -1 en zakken naar onderen.
const statusRank = (status) => ADRESS_STATUS_KEYS.indexOf(status)

// De vastgezette verwijderkolom. Kop en cel horen bij elkaar: zet je er maar
// een van, dan blijft de kop stil staan terwijl de knop wegschuift.
const STICKY_DELETE_HEAD = 'common-table__head-cell--sticky-right'
const STICKY_DELETE_CELL = 'common-table__cell--sticky-right'

// Hoe lang loopt de mislukte reeks al? Dat is wat 'onbereikbaar pas na x
// periode' straks afdwingt, dus het hoort zichtbaar te zijn in het overzicht
// in plaats van alleen in het huishouden zelf.
const waitingLabel = (firstFailedAt) => {
    const days = daysSince(firstFailedAt)
    if (days === null) return ''
    // Een reeks die nog moet beginnen wacht nog nergens op. Zonder deze grens
    // zou een datum in de toekomst hier '· -1 dagen' opleveren.
    // AI-CONTEXT: See docs/pitfalls.md#ui-negative-day-count-reads-as-days-ago
    if (days < 0) return ''
    return ` · ${days} ${days === 1 ? 'dag' : 'dagen'}`
}

const DATE_FORMATTER = new Intl.DateTimeFormat('nl-NL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
})

/**
 * Het em-streepje is een WEERGAVE-terugval: in de tabel moet de cel uitlijnen
 * met de kolomkop erboven. De kaart op het bord heeft die kop niet en laat een
 * leeg veld juist weg, dus die vraagt om ''.
 * AI-CONTEXT: See docs/pitfalls.md#ui-display-fallback-used-as-sort-key
 *
 * @param {*} timestamp - Firestore-tijdstempel
 * @param {string} [placeholder] - Wat er staat als er geen datum is
 * @returns {string}
 */
const formatRegistrationDate = (timestamp, placeholder = '—') => {
    if (!timestamp?.toDate) return placeholder
    return DATE_FORMATTER.format(timestamp.toDate())
}

// Korte notatie voor de twee kolommen die naast de datum ook een uitkomst of
// titel kwijt moeten — voluit geschreven maanden maken die cel te breed.
const SHORT_DATE_FORMATTER = new Intl.DateTimeFormat('nl-NL', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
})

/**
 * @param {*} timestamp - Firestore-tijdstempel
 * @param {string} [placeholder] - Wat er staat als er geen datum is; '' voor de kaart
 * @returns {string}
 */
const formatShortDate = (timestamp, placeholder = '—') => {
    if (!timestamp?.toDate) return placeholder
    return SHORT_DATE_FORMATTER.format(timestamp.toDate())
}

/**
 * De weergavefilters van het overzicht (locatie, ster, label), op één plek:
 * de rijen én de tellers op de statusknoppen gaan erdoorheen.
 * @param {Array<object>} list - Huishoudens
 * @param {{ selectedLocationId: string, starOnly: boolean, labelKey: string }} filters
 * @returns {Array<object>}
 */
const applyViewFilters = (list, { selectedLocationId, starOnly, labelKey }) => {
    const opLocatie = filterByLocation(list, selectedLocationId)
    const metSter = starOnly ? filterStarred(opLocatie) : opLocatie
    return labelKey ? metSter.filter((a) => hasLabel(a, labelKey)) : metSter
}

const readStatusFromSearch = (search) => {
    const params = new URLSearchParams(search)
    const fromUrl = params.get('status')
    return VALID_STATUSES.includes(fromUrl) ? fromUrl : 'planning'
}

const Overview = () => {
       // Context
    const [saved, setSaved] = useContext(SavedIcon)
    const [auth] = useContext(Auth)
    // Kan ontbreken buiten de provider (tests); dan alleen de route.
    const adressNavigationContext = useContext(AdressNavigation)
    const setAdressNavigation = Array.isArray(adressNavigationContext) ? adressNavigationContext[1] : undefined

    // State
    const [dragArray, setDragArray] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteDocid, setDeleteDocid] = useState('123')
    const [deleteName, setDeleteName] = useState('')
    const [boardError, setBoardError] = useState('')
    // Pas zoeken haalt alle gegevensregels op. Zolang niemand het zoekveld
    // aanraakt, blijft het overzicht bij de vijf titels die het toch al laadt.
    const [searchArmed, setSearchArmed] = useState(false)
    // Hetzelfde verhaal voor de export: die heeft ALLE gegevensregels nodig, en
    // haalt ze pas op zodra iemand het exportvenster opent.
    const [exportArmed, setExportArmed] = useState(false)
    const [exportMessage, setExportMessage] = useState('')

    // Hooks
    const history = useHistory()
    const location = useLocation()
    const id = uuid()

    const [selectedType, setSelectedType] = useState(() => readStatusFromSearch(location.search))
    // Het filter 'Met ster': een weergavekeuze van dit moment, niet in de url
    // en niet in Firestore. AI-CONTEXT: See docs/features/planner-overzicht-bkb.md
    const [starOnly, setStarOnly] = useState(false)
    // Het filter 'Label': één labelsleutel, '' = alle.
    const [labelKey, setLabelKey] = useState('')

    /**
     * Kiest een statustab en zet hem in de url, zodat herladen hem onthoudt
     * (testronde 2026-10-13, R1-B4). De rest van de url blijft staan.
     * @param {string} id - Statussleutel of 'all'
     */
    const selectStatus = (id) => {
        setSelectedType(id)
        const params = new URLSearchParams(location.search)
        params.set('status', id)
        history.replace({ search: `?${params.toString()}` })
    }

    useEffect(() => {
        const next = readStatusFromSearch(location.search)
        setSelectedType(prev => (prev === next ? prev : next))
    }, [location.search])

    // Firestore
    const allAdresses = useFirestoreOrderBy('Adresses', 'Position', 'asc')
    // Eén useSettings voor de hele pagina: die zet zijn eigen listeners op, en
    // twee aanroepen zouden hetzelfde document twee keer lezen. Niet per rij —
    // bij de grootste organisatie zijn dat er 394.
    const settings = useSettings()
    const { adressStatusConfig, householdColumns, defaultAgendaView, stickyDeleteColumn, adressLabels, wervingsDienstenConfig, loaded: settingsLoaded } = settings
    /** De labels van de organisatie, als kiesbare opties en als opzoektabel per sleutel. */
    const labelOptions = useMemo(() => (adressLabels || []).map((l) => ({ id: l.key, label: l.label })), [adressLabels])
    const labelByKey = useMemo(() => Object.fromEntries((adressLabels || []).map((l) => [l.key, l])), [adressLabels])
    // Diensten: dezelfde lijst als bij een wervingsactie, één per organisatie.
    // AI-CONTEXT: See docs/features/huishoudens-status-per-periode.md
    const dienstenZichtbaar = useMemo(() => resolveWervingsDiensten({ WervingsDiensten: wervingsDienstenConfig }), [wervingsDienstenConfig])
    const dienstNamen = useMemo(() => toDienstNamen({ WervingsDiensten: wervingsDienstenConfig }), [wervingsDienstenConfig])
    // 'Lijst en agenda' alleen met de module Huishoudens ('FIXtool'): zelfde
    // poort voor de knop en voor de url.
    const householdPlanning = householdPlanningEnabled(settings)
    // De weergave staat in de url, net als de statuskeuze. Zo blijft een
    // gedeelde link kloppen en blijft de deeplink van de dashboardkaart werken.
    // Zolang de instellingen laden blijft 'agenda' staan (die tak tekent dan
    // toch nog niets); daarna valt hij zonder de module terug op de tabel.
    const view = resolveBoardView(location.search, { householdPlanning: !settingsLoaded || householdPlanning })
    const statusDisplay = useMemo(
        () => statusDisplaysFrom({ adressStatusConfig }).adress,
        [adressStatusConfig],
    )
    // Welke kolommen deze organisatie wil zien, en welke eigen gegevens erbij.
    const { columns: resolvedColumns, extraTitles, contactDateOnly } = useMemo(
        () => resolveHouseholdColumns(householdColumns),
        [householdColumns],
    )
    // Soft delete (ADR-008): verwijderde huishoudens blijven in de collectie staan.
    const adresses = useMemo(
        () => (Array.isArray(allAdresses) ? allAdresses : []).filter(notDeleted),
        [allAdresses]
    )
    // `''` is de 'nog niet geladen'-waarde van de engine. Het verschil telt: een
    // kolom die '0' meldt en 'sleep hier een kaart naartoe' zegt, doet een
    // BEWERING over de gegevens — en die is onwaar zolang de read loopt.
    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    const adressesLoaded = Array.isArray(allAdresses)
    // Uit ÁLLE huishoudens en niet uit de rijen in de tabel: die zijn op de
    // statustab gefilterd, en een bezoek aan een huishouden op een andere tab
    // moet zijn status net zo goed tonen.
    const adressStatusById = useAdressStatusById(adresses, adressStatusConfig)
    // De oude titels voor straat en naam (`LABEL_LEGACY_TITLES`, 6 waarden)
    // reizen in één `in`-query — geen extra listener voor de NAAM-kolom. Nodig
    // tot de migratie; daarna staan straat en naam op het huishouden zelf.
    //
    // De eigen gegevens die de organisatie als kolom koos reizen in dezelfde
    // query mee. Boven de tien waarden hakt de engine de `in` zelf in stukken
    // (useFirestore.js), dus dit blijft werken zonder index en zonder aparte
    // hook. `useMemo` op de samengevoegde titels: een nieuwe array per render
    // zou de listener elke keer opnieuw opzetten.
    const dataTitles = useMemo(
        () => [...LABEL_LEGACY_TITLES, ...extraTitles],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [extraTitles.join('\n')],
    )
    const adressFields = useFirestoreGeneralIn('PersonaData', 'Title', dataTitles)

    // Map address ID -> eigen gegevens + vaste gegevens. De vaste (straat,
    // naam, telefoon …) staan op het huishouden zelf; tot de migratie vult
    // `readHouseholdField` ze aan uit de oude regels in `adressFields`.
    // Shared with the mobile "toegewezen aan mij" list.
    // AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
    // AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md (T6)
    const fieldsByAddressId = useMemo(() => buildStreetLabelMap(adressFields, adresses), [adressFields, adresses])

    // Hoe dit huishouden heet — één lezing voor de tabel, het bord, het zoeken
    // en de verwijdermelding.
    //
    // `householdLabel` en niet `streetLabel`: die laatste kent alleen
    // `Straatnaam` + `Huisnummer` uit PersonaData en geeft anders '—'. Platform-
    // breed tonen 38 van de 747 levende huishoudens zo'n streepje, en 15 daarvan
    // hebben wél een legacy `Adresses.Title` die de detailpagina in zijn kop
    // zet. De tabel noemde die huishoudens dus '—' terwijl het bord en de
    // detailpagina ze bij naam kenden — twee overzichten die het niet eens zijn
    // over hetzelfde record, en dat is precies waar een planner een lijst niet
    // meer vertrouwt. Gevonden in een /test-ronde, 2026-09-10.
    const getHouseholdLabel = (item) => householdLabel(fieldsByAddressId, item)
    const getNameLabel = (addressId) => nameLabel(fieldsByAddressId, addressId)

    // Zoeken gaat over ALLE gegevens van het tabblad 'Gegevens', niet alleen
    // over de straat: een huishouden wordt in de praktijk teruggezocht op een
    // telefoonnummer, een e-mailadres of de woningcorporatie.
    //
    // Die regels zijn een veelvoud van de vijf titels hierboven — bij de
    // grootste organisatie honderden huishoudens maal ruim tien regels — dus de
    // listener gaat pas open zodra iemand het zoekveld aanraakt. `enabled`
    // houdt hem tot die tijd dicht; er wordt niets gelezen.
    // AI-CONTEXT: See docs/features/huishouden-zoeken-alle-gegevens.md
    //
    // `view === TABLE_VIEW` erbij: het bord kan niet zoeken, en `searchArmed`
    // gaat nooit meer uit. Wie eerst zoekt en dan wisselt, hield anders een
    // listener op alle PersonaData-rijen open in een weergave die hem niet
    // gebruikt — bij de grootste organisatie 4.894 documenten.
    //
    // De export leest dezelfde regels, dus `exportArmed` opent dezelfde
    // listener in plaats van een tweede. Beide staan alleen in de tabel aan:
    // het bord kan niet zoeken en heeft geen exportknop.
    const allDataFields = useFirestoreQuery('PersonaData', {
        enabled: (searchArmed || exportArmed) && view === TABLE_VIEW,
    })
    // `''` is de 'nog niet geladen'-waarde van de engine. Het verschil telt:
    // zoeken door een halve lijst geeft 'geen resultaten' op een huishouden dat
    // er wel is.
    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    const allDataFieldsLoaded = Array.isArray(allDataFields)
    // `searchArmed` en niet alleen `allDataFieldsLoaded`: sinds de export
    // dezelfde regels vult, zou een gebruiker die alléén exporteert de hele
    // zoekindex over ~4.900 regels opbouwen — en opnieuw bij elke volgende
    // snapshot. De twee afnemers van deze index doen allebei niets zonder
    // zoekterm.
    const searchIndex = useMemo(
        () => buildHouseholdSearchIndex(searchArmed && allDataFieldsLoaded ? allDataFields : []),
        [allDataFields, allDataFieldsLoaded, searchArmed]
    )

    // De doorzoekbare tekst per huishouden. Straat en naam staan als kolom op
    // het scherm en zitten hier ook in, zodat één zoekveld alles dekt. Zonder
    // placeholder: het em-streepje van een leeg veld is voor een zoekopdracht
    // gewoon tekst, en zou dan elk naamloos huishouden als treffer opleveren.
    //
    // `useCallback`: de tabel filtert opnieuw zodra deze functie een andere
    // identiteit heeft. Nu alleen als de gegevens zelf wijzigen, en dat scheelt
    // het doorzoeken van honderden huishoudens per toetsaanslag.
    const householdSearchValue = useCallback((adress) => [
        // Dezelfde lezing als de kolom STRAAT, dus een huishouden dat daar op
        // zijn legacy titel staat is ook op die titel te vinden.
        householdLabel(fieldsByAddressId, adress, ''),
        nameLabel(fieldsByAddressId, adress.ID, ''),
        householdSearchText(searchIndex, adress.ID),
        // Na de migratie staan telefoon, e-mail en corporatie op het huishouden
        // en niet meer in de regels die de index leest.
        fixedFieldSearchText(adress),
    ].join('\n'), [fieldsByAddressId, searchIndex])

    const searchSummary = (shown, total) => (
        allDataFieldsLoaded
            ? `${shown} van ${total} huishoudens`
            : 'Gegevens worden opgehaald…'
    )

    // Contactmomenten en afspraken in één keer per tenant, via de gedeelde
    // listener — een query per rij zou 394 listeners openen op de grootste
    // tenant. Beide collecties tellen daar honderden documenten.
    // Eén gedeelde instelling met de deelnemers: dezelfde Locations-collectie,
    // hetzelfde veld `LocationID`. Een fixbrigade heeft fixers én huishoudens op
    // dezelfde locatie. AI-CONTEXT: See docs/features/huishouden-locaties.md
    const locations = useSharedCollection('Locations')
    const [selectedLocationId, setSelectedLocationId] = useState('')

    const contactMoments = useSharedCollection('ContactMoments')
    // Twee listeners, één per soort: de afspraken en de subtaken van de nieuwe
    // vorm (die hebben een eigen Type en, als ze nog niet ingepland zijn, geen
    // Parent). Twee `==`-listeners in plaats van één `in`-zoekopdracht, want de
    // gedeelde cache is per (veld, waarde) en de dashboardkaarten houden de
    // eerste al open; de samengestelde index (CompagnyID, Type) dekt allebei.
    // Subtaken van de oude vorm zitten gewoon in de eerste.
    // AI-CONTEXT: See docs/features/subtaken-bij-het-huishouden.md
    const visits = useSharedCollectionWhere('Tasks', 'Type', APPOINTMENT_TYPE)
    const subtasks = useSharedCollectionWhere('Tasks', 'Type', SUBTASK_TYPE)
    // `undefined` zolang één van de twee nog niets gaf: anders leest 'geen
    // taken' als waar terwijl de subtaken nog onderweg zijn.
    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    const tasks = useMemo(
        () => (Array.isArray(visits) && Array.isArray(subtasks) ? [...visits, ...subtasks] : undefined),
        [visits, subtasks]
    )
    // Alle notities van de organisatie in één keer, net als de taken hierboven:
    // per rij tellen zou bij de grootste organisatie honderden zoekopdrachten zijn.
    const notes = useSharedCollection('AdressNotes')

    const latestContact = useMemo(
        () => latestContactPerAdress(contactMoments),
        [contactMoments]
    )

    // `now` wordt vastgezet op het moment dat de takenlijst binnenkomt. Voor een
    // overzicht dat dagenlang openstaat betekent dat een afspraak van vandaag
    // blijft staan tot de volgende snapshot — acceptabel, en beter dan elke
    // render opnieuw rekenen.
    const nextVisit = useMemo(() => nextVisitPerAdress(tasks), [tasks])

    // De ID's mét toekomstige afspraak, als Set met een STABIELE identiteit:
    // alleen nieuw als de verzameling zelf verandert. Een nieuwe map-referentie
    // per snapshot zou anders `visibleItems` elke render vernieuwen.
    // AI-CONTEXT: See docs/pitfalls.md#state-useeffect-inline-filter
    const plannedKey = Object.keys(nextVisit).sort().join('|')
    const plannedIds = useMemo(() => new Set(plannedKey ? plannedKey.split('|') : []), [plannedKey])

    const openTasks = useMemo(() => openTasksPerAdress(tasks), [tasks])
    const noteCounts = useMemo(() => notesPerAdress(notes), [notes])

    // `tasks` is undefined zolang één van de twee listeners nog niets gaf. Een
    // streepje zou dan beweren dat er geen taken zijn, en dat is een uitspraak
    // aan de lezer die op dat moment niet waar is. Een LEGE lijst is wél geladen:
    // een organisatie zonder één taak hoort '—' te zien en niet eeuwig 'Laden…'.
    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    const tasksLoaded = Array.isArray(tasks)
    // `''` is de 'nog niet geladen'-waarde van de engine; een echte lege lijst
    // is een array. Anders dan bij de taken telt een LEGE lijst hier als
    // geladen: een organisatie die nog nooit een notitie maakte hoort '—' te
    // zien en niet eeuwig 'Laden…'.
    const notesLoaded = Array.isArray(notes)

    /**
     * Wat er in de kolom TAKEN staat.
     *
     * Drie takken in deze volgorde: eerst 'weet ik nog niet', dan 'geen', dan
     * de inhoud. Zonder die eerste tak leest een huishouden mét openstaand werk
     * tijdens het laden als een huishouden zonder werk.
     *
     * @param {string} addressId
     * @param {string} [leeg] - Terugval op de kaart, waar een streepje niet past
     * @returns {string}
     */
    const taskLabel = (addressId, leeg = '—') => {
        if (!tasksLoaded) return leeg === '' ? '' : 'Laden…'

        const telling = openTasks[addressId]
        if (!telling || telling.totaal === 0) return leeg
        if (telling.open === 0) return 'Klaar'

        return telling.open === telling.totaal
            ? `${telling.open} te doen`
            : `${telling.open} van ${telling.totaal} te doen`
    }

    /**
     * Wat er in de kolom NOTITIES komt te staan.
     *
     * Drie takken op volgorde van zekerheid: eerst 'weet ik nog niet', dan
     * 'geen', dan het aantal. Een streepje tonen terwijl de notities nog
     * onderweg zijn is een bewering aan de lezer dat er niets vastligt, en die
     * is op dat moment onwaar.
     * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
     *
     * @param {string} addressId - Adresses.ID
     * @param {string} [leeg] - Wat er staat als er geen notities zijn
     * @returns {string}
     */
    const noteLabel = (addressId, leeg = '—') => {
        if (!notesLoaded) return leeg === '' ? '' : 'Laden…'

        const aantal = noteCounts[addressId] || 0
        if (aantal === 0) return leeg

        return aantal === 1 ? '1 notitie' : `${aantal} notities`
    }

    // Deelnemers that can be assigned to a household — same set as the task
    // team picker (personas only; team users have no mobile persona link).
    const personas = useFirestoreGeneral('Personas', 'Status', 'active')

    const personaOptions = useMemo(
        () => (personas || [])
            .filter(p => p?.ID)
            .map(p => ({ id: p.ID, label: p.Name || 'Naamloze deelnemer' })),
        [personas]
    )

    const personaNameById = useMemo(() => {
        const map = {};
        (personas || []).forEach(p => { if (p?.ID) map[p.ID] = p.Name || 'Naamloze deelnemer' });
        return map;
    }, [personas])

    // Assign / unassign a deelnemer on one household. arrayUnion/arrayRemove
    // instead of writing the whole array: the dropdown stays open for several
    // ticks in a row, and a read-modify-write would drop a selection whenever
    // the next click lands before the snapshot of the previous one.
    const assignedToHandler = async (item, personaId, isSelected) => {
        if (!item?.docid || !personaId) return

        await db.collection('Adresses')
            .doc(item.docid)
            .update({
                AssignedTo: isSelected
                    ? firebase.firestore.FieldValue.arrayRemove(personaId)
                    : firebase.firestore.FieldValue.arrayUnion(personaId),
            })

        setSaved('flex')
    }
     // Delete modal
     const deleteModalHandler = (e) => {
        const docid = e.currentTarget.dataset.docid
        const deleteName = e.currentTarget.dataset.deletename

        setDeleteDocid(docid)
        setDeleteName(deleteName)
        setDeleteModal(!deleteModal)
    }

    // Labels en zichtbaarheid komen uit de instelling van de organisatie; de
    // regels erachter (verborgen maar nog bezet, en de tab waar je nu naar
    // kijkt) staan in buildStatusTabs, met tests.
    // De tab 'Inplannen' telt alles wat ingepland moet worden — ook een
    // vervolgopdracht zonder toekomstige afspraak — met dezelfde regel als de
    // lijst eronder (planningQueue). Zolang de afspraken laden alleen de status.
    // De tellers volgen dezelfde filters als de rijen (locatie, ster, label):
    // de knop zei 'Ingepland 7' boven 'Nog geen huishoudens gevonden.' (testronde 2026-10-13).
    // AI-CONTEXT: See docs/pitfalls.md#ui-export-claims-everything-on-screen
    const gefilterdeAdressen = useMemo(
        () => applyViewFilters(adresses || [], { selectedLocationId, starOnly, labelKey }),
        [adresses, selectedLocationId, starOnly, labelKey]
    )
    const options = useMemo(() => buildStatusTabs({
        display: statusDisplay,
        counts: {
            ...countByStatus(gefilterdeAdressen, ADRESS_STATUS_KEYS),
            planning: planningQueueCount(gefilterdeAdressen, tasksLoaded ? plannedIds : null),
        },
        selectedKey: selectedType,
        total: gefilterdeAdressen.length,
    }), [gefilterdeAdressen, statusDisplay, selectedType, tasksLoaded, plannedIds])

    // Whenever Firestore data changes, update dragArray state
    // AI-CONTEXT: See docs/pitfalls.md#state-useeffect-inline-filter
    useEffect(() => {
        setDragArray(adresses || []);
    }, [adresses]);

    // DRAG & DROP: reorder items and update Firestore
    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(dragArray);
        const [movedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, movedItem);

        // Update local state to reflect the reorder immediately
        setDragArray(items);

        // Now update Firestore with new positions
        items.forEach((item, idx) => {
        db.collection('Adresses')
            .doc(item.docid) // assuming .docid is stored for each doc
            .update({ Position: idx + 1 });
        });

        // Show "saved" icon
        setSaved('flex');
    };

    // Add Adress with default PersonaData fields
    const addAdress = async () => {
        const newId = uuid()

        // Het huishouden hoort op het tabblad te blijven staan waar je het
        // aanmaakt. Kreeg het altijd 'planning', dan sprong het vanaf elk ander
        // tabblad meteen uit beeld en las dat als een mislukte aanmaak.
        // 'all' is geen status maar een verzameling, dus daar begint het
        // traject gewoon bij het begin van de trechter.
        const newStatus = selectedType === 'all' ? 'planning' : selectedType

        await db.collection('Adresses')
            .doc()
            .set({
                Title: '',
                ID: newId,
                Compagny: client,
                CompagnyID: client,
                Timestamp: timestamp,
                Research: [],
                Position: adresses.length + 1,
                Status: newStatus,
                AssignedTo: [],
            })

        // Beginregel van de statushistorie: hier begint het traject.
        await recordStatusChange({
            entityType: 'adress',
            entityID: newId,
            toStatus: newStatus,
            changedBy: auth?.ID,
        })

        // Alleen nog eigen gegevens: naam, adres, contact en type woning zijn
        // vaste gegevens op het huishouden en staan op de kaart (T11).
        // AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md
        const defaultFields = [
            'Bijzonderheden',
        ]

        for (let i = 0; i < defaultFields.length; i++) {
            await db.collection('PersonaData').add({
                ID: uuid(),
                PersonaID: newId,
                Title: defaultFields[i],
                Value: '',
                CompagnyID: client,
                Compagny: client,
                Position: i + 1,
                Timestamp: timestamp,
            })
        }

        // Meteen naar het nieuwe huishouden, op het tabblad 'Gegevens': daar
        // moet toch als eerste iets ingevuld worden. Anders stond het als
        // 'Naamloos huishouden' in de lijst en moest je het zelf opzoeken
        // (verzoek BuurtKlusBedrijf 2026-09-28). De navigatiecontext eerst,
        // dan de route -- andersom opent de pagina op het dashboardtabblad.
        if (typeof setAdressNavigation === 'function') setAdressNavigation('data')
        history.push(`/${client}/adressdetails/${newId}`)
    }

    /**
     * Een kaart is naar een andere kolom gesleept.
     *
     * Doet precies wat `statusHandler` doet bij de keuzelijst in de tabel — het
     * bord is een tweede manier om dezelfde handeling te doen, geen tweede
     * schrijfpad.
     *
     * De volgorde is niet vrij. Eerst de status, dan pas de historie: die
     * tweede stap verrijkt alleen en mag de eerste nooit laten mislukken.
     * `recordStatusChange` faalt zelf al nooit hard, en een fout dáár mag geen
     * 'kon niet opslaan' opleveren terwijl de status er wél staat.
     * AI-CONTEXT: See docs/pitfalls.md#api-error-claims-nothing-was-saved
     *
     * Er wordt bewust GEEN lokale kopie van de lijst bijgehouden. Het bord
     * tekent zich uit de Firestore-snapshot, dus een mislukte schrijfactie
     * betekent dat de kaart nooit verspringt — hij staat vanzelf weer in zijn
     * oude kolom, zonder dat we iets terug hoeven te draaien.
     *
     * @param {{itemId: string, from: string, to: string}} move
     */
    const boardMoveHandler = async ({ itemId, from, to }) => {
        const adress = (adresses || []).find((item) => item.ID === itemId)
        if (!adress) return

        try {
            await db.collection('Adresses').doc(adress.docid).update({ Status: to })
        } catch (error) {
            // Zichtbaar laten mislukken: zonder melding lijkt de kaart gewoon
            // terug te springen en weet niemand waarom.
            console.error('Status wijzigen vanaf het bord mislukt', error)
            setBoardError('De status kon niet worden gewijzigd. Probeer het opnieuw.')
            return
        }

        setBoardError('')

        await recordStatusChange({
            entityType: 'adress',
            entityID: itemId,
            fromStatus: from,
            toStatus: to,
            changedBy: auth?.ID,
        })

        setSaved('flex')
    }

    const statusHandler = async (e) => {

        const docid = e.target.dataset.docid
        const adressID = e.target.dataset.id
        const previousStatus = e.target.dataset.status
        const value = e.target.options[e.target.selectedIndex].value

        await db.collection('Adresses')
        .doc(docid)
        .update({
            Status: value,
        })

        await recordStatusChange({
            entityType: 'adress',
            entityID: adressID,
            fromStatus: previousStatus,
            toStatus: value,
            changedBy: auth?.ID,
        })

        setSaved('flex')

    }


    // Delete Persona
    // Soft delete (ADR-008): markeer het huishouden in plaats van het te wissen,
    // en cascadeer naar alles wat eraan hangt. Een harde delete liet afspraken,
    // adresgegevens en materialen als wezen achter — die verwezen naar een ID
    // dat nergens meer bestond.
    const deleteAdress = async () => {
        const adress = (Array.isArray(adresses) ? adresses : [])
            .find((item) => item.docid === deleteDocid)

        await softDeleteAdress({
            adressDocid: deleteDocid,
            adressId: adress?.ID || '',
            authId: auth?.ID,
        })

        setSaved('flex')
    }

    // De kolom LOCATIE staat er alleen bij een organisatie die met meer dan één
    // locatie werkt — bij nul of één valt er niets te kiezen en is hij ruis.
    // Zelfde drempel als het bestaande filter bij de deelnemers.
    const visibleColumns = useMemo(
        () => (hasLocationFilter(locations)
            ? resolvedColumns
            : resolvedColumns.filter((column) => column.key !== 'location')),
        [resolvedColumns, locations],
    )

    // Het locatiefilter is een WEERGAVEfilter: leeg is alles, en iedereen kan
    // elke locatie kiezen. Bewust geen afscherming — ze willen juist bij elkaar
    // kunnen kijken. AI-CONTEXT: See docs/features/huishouden-locaties.md
    // AI-CONTEXT: See docs/pitfalls.md#state-useeffect-inline-filter
    const visibleItems = useMemo(
        () => {
            const metSter = applyViewFilters(dragArray, { selectedLocationId, starOnly, labelKey })
            if (selectedType === 'all') return metSter
            // 'Inplannen' is breder dan de status: zie planningQueue.
            if (selectedType === 'planning') return planningQueue(metSter, tasksLoaded ? plannedIds : null)
            return metSter.filter(a => a.Status === selectedType)
        },
        [dragArray, selectedType, selectedLocationId, tasksLoaded, plannedIds, starOnly, labelKey]
    )

    /**
     * Een label aan- of uitzetten op een huishouden; de andere blijven staan.
     * @param {object} item - Het huishouden
     * @param {string} key - De labelsleutel
     * @param {boolean} on
     */
    const labelHandler = async (item, key, on) => {
        await db.collection('Adresses').doc(item.docid).update(labelPatch(item, key, on))
        setSaved('flex')
    }

    /**
     * Een dienst aan- of uitzetten op een huishouden. arrayUnion/arrayRemove en
     * niet de hele lijst, net als 'Toegewezen aan': twee snelle klikken (of twee
     * tabbladen) overschrijven elkaar anders.
     * @param {object} item - Het huishouden
     * @param {string} key - De dienstsleutel
     * @param {boolean} isSelected - De HUIDIGE stand, zoals MultiSelect hem meegeeft
     */
    const dienstHandler = async (item, key, isSelected) => {
        await db.collection('Adresses').doc(item.docid).update({
            Diensten: isSelected
                ? firebase.firestore.FieldValue.arrayRemove(key)
                : firebase.firestore.FieldValue.arrayUnion(key),
        })
        setSaved('flex')
    }

    /**
     * De ster 'extra aandacht' zetten of weghalen, met wie en wanneer.
     * @param {object} item - Het huishouden
     * @param {boolean} next - De nieuwe stand
     */
    const starHandler = async (item, next) => {
        await db.collection('Adresses').doc(item.docid).update(starredPatch(next, auth?.ID, timestamp))
        setSaved('flex')
    }

    /**
     * De exportgroep van een huishouden: zijn status, of '' als die leeg is of
     * niet in de vaste lijst staat. Zonder die lege groep zou zo'n huishouden
     * bij geen enkel vinkje horen en stil uit elke export vallen.
     * @param {{Status?: string}} item
     * @returns {string}
     */
    const exportGroupOf = useCallback(
        (item) => ((statusDisplay.keys || ADRESS_STATUS_KEYS).includes(item?.Status) ? item.Status : ''),
        [statusDisplay]
    )

    /**
     * De keuzelijst van het exportvenster: ALLE huishoudens van de organisatie,
     * los van de statustab, de zoekterm en de filters op het scherm. Welke
     * statussen meegaan kiest de gebruiker in het venster zelf — zo belooft het
     * venster niets wat het scherm anders laat zien.
     * Verzoek Duurzame Vecht (2026-10-22).
     * AI-CONTEXT: See docs/pitfalls.md#ui-export-claims-everything-on-screen
     */
    const exportItems = useMemo(
        () => adresses.map((item) => ({
            id: item.ID,
            label: householdLabel(fieldsByAddressId, item),
            group: exportGroupOf(item),
        })),
        [adresses, fieldsByAddressId, exportGroupOf]
    )

    /**
     * De statussen om (uit) te vinken: alleen die waar ook echt een huishouden
     * op staat, in de volgorde van de trechter, en 'Zonder status' achteraan.
     */
    const exportGroups = useMemo(() => {
        const aanwezig = new Set(exportItems.map((item) => item.group))
        const groepen = (statusDisplay.keys || ADRESS_STATUS_KEYS)
            .filter((key) => aanwezig.has(key))
            .map((key) => ({ id: key, label: statusDisplay.labels?.[key] || key }))
        return aanwezig.has('') ? [...groepen, { id: '', label: 'Zonder status' }] : groepen
    }, [exportItems, statusDisplay])

    /**
     * Of álle vier de bronnen van een exportrij binnen zijn.
     *
     * Niet alleen de gegevensregels: 'Open taken' komt uit `tasks`, 'Laatste
     * contact' uit `contactMoments` en 'Toegewezen aan' uit `personas`. Wie
     * daar niet op wacht, schrijft een zelfverzekerde 0 en 'Onbekende
     * deelnemer' het bestand in — en dat is niet te onderscheiden van een
     * huishouden zonder werk.
     * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
     * AI-CONTEXT: See docs/pitfalls.md#ui-export-claims-everything-on-screen
     */
    const exportDataLoaded = allDataFieldsLoaded
        && Array.isArray(contactMoments)
        && Array.isArray(tasks)
        && Array.isArray(personas)

    /**
     * Zet de gekozen huishoudens in een CSV en start de download.
     *
     * De eerste tak is niet beleefdheid maar de kern: de gegevensregels komen
     * pas binnen nadat het venster is geopend, en exporteren vóórdat ze er zijn
     * levert een bestand op waarin elke eigen kolom leeg is — zonder fout, en
     * niet te onderscheiden van een organisatie die niets heeft ingevuld.
     * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
     *
     * @param {{scope: 'all'|'selected', selectedIds: Array<string>, startDate: Date|null, endDate: Date|null, format: 'xlsx'|'csv', groupIds?: Array<string>}} selection
     */
    const exportHandler = (selection) => {
        if (!exportDataLoaded) {
            setExportMessage('De gegevens worden nog opgehaald. Probeer het zo nog een keer.')
            return
        }

        const gekozen = filterExportRows(adresses, selection, {
            getId: (item) => item.ID,
            getGroup: exportGroupOf,
            getDate: (item) => (item.Timestamp?.toDate ? item.Timestamp.toDate() : null),
        })

        const { rows, header } = buildHouseholdExportRows(gekozen, {
            personaData: allDataFields,
            statusLabels: statusDisplay.labels,
            latestContact,
            nextVisit,
            openTasks,
            personaNameById,
        })

        const written = downloadDatedExport(rows, { prefix: 'Huishoudens', format: selection.format, header })

        setExportMessage(written ? '' : 'Geen huishoudens gevonden voor deze keuze.')
    }

    // Kolomdefinitie en cel in ÉÉN lijst.
    //
    // De koprij en de rij worden hieruit allebei opgebouwd, zodat ze niet uit
    // elkaar kunnen lopen. Zet je een kolom uit en vergeet je de bijbehorende
    // cel, dan schuift elke waarde een plek op zonder dat er iets stukgaat:
    // geen foutmelding, geen rode test, alleen een tabel waarin het
    // telefoonnummer onder 'Aanmelddatum' staat.
    /** De locaties op naam, voor de kolom en het filter. */
    // Huishouden -> locatie, voor de agendaweergave: een huisbezoek draagt zelf
    // geen locatie en erft hem hiervan.
    const locationByAdressId = useMemo(() => buildLocationByAdressId(adresses), [adresses])

    const locationOptions = useMemo(
        () => sortLocations(locations)
            .map((loc) => ({ value: loc.docid, label: loc.Title || 'Naamloze locatie' })),
        [locations],
    )
    const locationNameByDocid = useMemo(
        () => locationOptions.reduce((acc, o) => ({ ...acc, [o.value]: o.label }), {}),
        [locationOptions],
    )

    /**
     * De locatie van één huishouden zetten.
     *
     * De waarde is de Firestore-docid van het locatiedocument — zo doen de
     * deelnemers en de roosterregels het ook.
     * AI-CONTEXT: See docs/features/huishouden-locaties.md
     */
    const locationHandler = async (item, value) => {
        if (!item?.docid) return
        await db.collection('Adresses').doc(item.docid).update({ [LOCATION_KEY]: value })
        setSaved('flex')
    }

    const columnConfig = {
        title: {
            headerClassName: 'adress-overview-col-street',
            sortable: true,
            // Sorteren op de kale waarde: het em-streepje uit de weergave is
            // voor een collator gewoon tekst en sorteert vóór elke letter.
            // AI-CONTEXT: See docs/pitfalls.md#ui-display-fallback-used-as-sort-key
            sortAccessor: (item) => householdLabel(fieldsByAddressId, item, ''),
            // Geen `value`: op het bord is dit de KOP van de kaart, geen veld.
            cell: (item, searchTerm) => (
                <TableTitleCell
                    className="adress-overview-col-street"
                    value={getHouseholdLabel(item)}
                    to={`/${client}/adressdetails/${item.ID}`}
                    readOnly
                    footer={(
                        <HouseholdSearchHit
                            hit={findHouseholdSearchHit(searchIndex, item.ID, searchTerm)}
                            searchTerm={searchTerm}
                        />
                    )}
                />
            ),
        },
        name: {
            searchable: false,
            sortable: true,
            sortAccessor: (item) => nameLabel(fieldsByAddressId, item.ID, ''),
            cell: (item) => <TableCell><p>{getNameLabel(item.ID)}</p></TableCell>,
            // Kale waarde voor de kaart op het bord: leeg blijft leeg, want daar
            // valt een leeg veld weg in plaats van een streepje te tonen.
            value: (item) => nameLabel(fieldsByAddressId, item.ID, ''),
        },
        status: {
            searchable: false,
            sortable: true,
            sortAccessor: (item) => item.Status,
            sortRank: statusRank,
            // Geen `value`: op het bord is de status de KOLOM waar de kaart in
            // staat, dus hem er ook op zetten is dubbelop.
            cell: (item) => (
                <TableCell>
                    <AdressStatusSelect value={item.Status} display={statusDisplay} docid={item.docid} id={item.ID} onChange={statusHandler} />
                </TableCell>
            ),
        },
        registered: {
            searchable: false,
            sortable: true,
            sortAccessor: (item) => item.Timestamp,
            cell: (item) => <TableCell><p>{formatRegistrationDate(item.Timestamp)}</p></TableCell>,
            value: (item) => formatRegistrationDate(item.Timestamp, ''),
        },
        contact: {
            searchable: false,
            sortable: true,
            sortAccessor: (item) => latestContact[item.ID]?.timestamp,
            cell: (item) => (
                <TableCell>
                    {latestContact[item.ID] ? (
                        <>
                            <p>
                                {formatShortDate(latestContact[item.ID].timestamp)}
                                {/* Alleen de datum als de organisatie dat zo heeft ingesteld
                                    (Instellingen → Ondersteuning → kolommen). Uitkomst en
                                    reeks blijven in de export en op het huishouden zelf. */}
                                {!contactDateOnly && ' · '}
                                {!contactDateOnly && (OUTCOME_LABELS[latestContact[item.ID].outcome] || 'Onbekend')}
                            </p>
                            {!contactDateOnly && latestContact[item.ID].failedStreak > 0 && (
                                <p className="adress-overview-streak">
                                    {`${latestContact[item.ID].failedStreak}× geen contact`}
                                    {waitingLabel(latestContact[item.ID].firstFailedAt)}
                                </p>
                            )}
                        </>
                    ) : <p>—</p>}
                </TableCell>
            ),
            // Twee regels, net als in de tabelcel. De tweede is het signaal
            // waar de knop 'Onbereikbaar' aan hangt (#120 laag E); zonder die
            // regel mist de kaart precies waar een planner op werkt.
            //
            // Lege terugval, geen streepje: `latestContact[...].timestamp` is
            // bewust `null` zolang de server zijn tijdstempel nog niet heeft
            // ingevuld (latestContactPerAdress.js), en dan zou er op de kaart
            // '— · Geen gehoor' staan.
            value: (item) => {
                const contact = latestContact[item.ID]
                if (!contact) return ''
                const wanneer = formatShortDate(contact.timestamp, '')
                if (contactDateOnly) return wanneer
                const uitkomst = OUTCOME_LABELS[contact.outcome] || 'Onbekend'
                const eerste = [wanneer, uitkomst].filter(Boolean).join(' · ')
                if (!(contact.failedStreak > 0)) return eerste
    return (
                    <>
                        {eerste}
                        <span className="household-card__streak">
                            {`${contact.failedStreak}× geen contact`}
                            {waitingLabel(contact.firstFailedAt)}
                        </span>
                    </>
                )
            },
        },
        visit: {
            searchable: false,
            sortable: true,
            sortAccessor: (item) => nextVisit[item.ID]?.Timestamp,
            cell: (item) => (
                <TableCell>
                    {nextVisit[item.ID] ? (
                        <p>{formatShortDate(nextVisit[item.ID].Timestamp)}</p>
                    ) : <p>—</p>}
                </TableCell>
            ),
            value: (item) => (nextVisit[item.ID] ? formatShortDate(nextVisit[item.ID].Timestamp, '') : ''),
        },
        tasks: {
            searchable: false,
            sortable: true,
            // Op het GETAL sorteren en niet op de tekst in de cel: 'Klaar' en
            // '—' zouden anders tussen de aantallen gaan staan.
            // AI-CONTEXT: See docs/pitfalls.md#ui-display-fallback-used-as-sort-key
            sortAccessor: (item) => openTasks[item.ID]?.open ?? 0,
            cell: (item) => <TableCell><p>{taskLabel(item.ID)}</p></TableCell>,
            value: (item) => taskLabel(item.ID, ''),
        },
        notes: {
            searchable: false,
            sortable: true,
            // Op het GETAL sorteren en niet op de tekst in de cel: '—' en
            // 'Laden…' zouden anders tussen de aantallen gaan staan.
            // AI-CONTEXT: See docs/pitfalls.md#ui-display-fallback-used-as-sort-key
            sortAccessor: (item) => noteCounts[item.ID] || 0,
            cell: (item) => <TableCell><p>{noteLabel(item.ID)}</p></TableCell>,
            value: (item) => noteLabel(item.ID, ''),
        },
        assigned: {
            searchable: false,
            cell: (item) => (
                <TableCell>
                    <MultiSelect
                        selected={Array.isArray(item.AssignedTo) ? item.AssignedTo : []}
                        options={personaOptions}
                        onToggle={(personaId, isSelected) => assignedToHandler(item, personaId, isSelected)}
                        renderSelected={(personaId) => <span>{personaNameById[personaId] || 'Onbekende deelnemer'}</span>}
                        addLabel="+ Deelnemer"
                        emptyLabel="Niemand toegewezen"
                        emptyOptionsLabel="Geen actieve deelnemers gevonden"
                        removeAriaLabel="Deelnemer verwijderen"
                    />
                </TableCell>
            ),
            value: (item) => (Array.isArray(item.AssignedTo) ? item.AssignedTo : [])
                .map((personaId) => personaNameById[personaId] || 'Onbekende deelnemer')
                .join(', '),
        },
        selfPickup: {
            searchable: false,
            sortable: true,
            // Op de boolean sorteren en niet op de cel: die bevat een schakelaar
            // en geen tekst. Aangevinkt bovenaan bij aflopend sorteren.
            // AI-CONTEXT: See docs/pitfalls.md#ui-display-fallback-used-as-sort-key
            sortAccessor: (item) => (isSelfPickup(item) ? 1 : 0),
            // ToggleButton schrijft zelf naar Adresses en zet het opgeslagen-icoon;
            // de hele tabel staat al in een ReadOnlyGuard op 'addresses.edit'.
            cell: (item) => (
                <TableCell>
                    <ToggleButton
                        docid={item.docid}
                        id="SelfPickup"
                        value={item.SelfPickup}
                        collection="Adresses"
                    />
                </TableCell>
            ),
            value: (item) => (isSelfPickup(item) ? 'Ja' : 'Nee'),
        },
        labels: {
            searchable: false,
            sortable: false,
            cell: (item) => (
                <TableCell>
                    {/* Dezelfde chip-kiezer als 'Toegewezen aan'. Een label dat
                        de organisatie verborgen heeft blijft op het huishouden
                        staan maar is hier niet te zien of te kiezen. */}
                    <MultiSelect
                        selected={labelsOf(item).filter((key) => labelByKey[key])}
                        options={labelOptions}
                        // MultiSelect geeft de HUIDIGE stand mee: aangevinkt = weghalen.
                        onToggle={(key, isSelected) => labelHandler(item, key, !isSelected)}
                        renderSelected={(key) => (
                            <span className={`label-chip label-chip--${labelByKey[key]?.color || 'grey'}`}>{labelByKey[key]?.label || key}</span>
                        )}
                        addLabel="+ Label"
                        emptyLabel="—"
                        emptyOptionsLabel="Geen labels ingesteld"
                        removeAriaLabel="Label verwijderen"
                    />
                </TableCell>
            ),
            value: (item) => labelsOf(item).map((key) => labelByKey[key]?.label).filter(Boolean).join(', '),
        },
        diensten: {
            searchable: false,
            sortable: false,
            cell: (item) => {
                // Een verborgen dienst die het huishouden nog draagt blijft
                // zichtbaar en uit te zetten, zoals in de wervingsactie.
                const keuzes = dienstKeuzes(dienstenZichtbaar, dienstenOf(item), dienstNamen)
                // Elke gedragen sleutel staat in `keuzes` (desnoods als 'Onbekende dienst').
                const naamVan = (key) => keuzes.find((d) => d.key === key).label
                return (
                    <TableCell>
                        <MultiSelect
                            selected={dienstenOf(item)}
                            options={keuzes.map((d) => ({ id: d.key, label: d.label }))}
                            onToggle={(key, isSelected) => dienstHandler(item, key, isSelected)}
                            renderSelected={(key) => <span className="label-chip label-chip--grey label-chip--dienst" title={naamVan(key)}>{naamVan(key)}</span>}
                            addLabel="+ Dienst"
                            emptyLabel="—"
                            emptyOptionsLabel="Geen diensten ingesteld"
                            removeAriaLabel="Dienst verwijderen"
                        />
                    </TableCell>
                )
            },
            value: (item) => dienstKeuzes(dienstenZichtbaar, dienstenOf(item), dienstNamen)
                .filter((d) => dienstenOf(item).includes(d.key))
                .map((d) => d.label)
                .join(', '),
        },
        location: {
            searchable: true,
            sortable: true,
            // Op de NAAM sorteren en niet op de docid: die is willekeurig.
            // Lege waarde als sorteersleutel, zodat huishoudens zonder locatie
            // onderaan komen in plaats van tussen de namen.
            // AI-CONTEXT: See docs/pitfalls.md#ui-display-fallback-used-as-sort-key
            sortAccessor: (item) => locationNameByDocid[item?.[LOCATION_KEY]] || '',
            cell: (item) => (
                <TableCell>
                    <select
                        value={item?.[LOCATION_KEY] || ''}
                        onChange={(e) => locationHandler(item, e.target.value)}
                        aria-label="Locatie"
                    >
                        <option value="">-- Geen locatie --</option>
                        {locationOptions.map((o) => (
                            <option key={o.value} value={o.value}>{o.label}</option>
                        ))}
                    </select>
                </TableCell>
            ),
            value: (item) => locationNameByDocid[item?.[LOCATION_KEY]] || '',
        },
    }

    /**
     * De waarde van een eigen gegeven bij één huishouden; '' als het er niet is.
     * Staat de kolom op de titel van een vast gegeven ('Telefoonnummer',
     * 'Woonplaats'), dan het vaste veld: die regel verdwijnt bij de migratie.
     */
    const extraValue = (addressId, titel) => {
        const entry = fieldsByAddressId[addressId] || {}
        const field = fixedFieldForTitle(titel)
        if (field) return formatHouseholdField(field, entry[field])
        return entry[titel] || ''
    }

    const tableColumns = [
        { key: 'drag', label: '', searchable: false },
        { key: 'star', label: '', searchable: false },
        ...visibleColumns.map((column) => ({
            key: column.key,
            label: column.label,
            ...columnConfig[column.key],
            // `cell` hoort niet in de kolomdefinitie van Table; die leest hij niet.
            cell: undefined,
        })),
        ...extraTitles.map((titel) => ({
            key: `extra:${titel}`,
            label: titel.toUpperCase(),
            searchable: false,
            sortable: true,
            // Kale waarde, geen streepje — zie de opmerking bij `title`.
            sortAccessor: (item) => extraValue(item.ID, titel),
        })),
        { key: 'edit', label: 'AANPASSEN', searchable: false },
        {
            key: 'delete',
            label: 'VERWIJDEREN',
            searchable: false,
            // Alleen als de organisatie het aanzet: met veel eigen kolommen
            // scrolt de verwijderknop uit beeld, met een handvol is een kolom
            // die over de tabel heen ligt juist in de weg.
            headerClassName: stickyDeleteColumn ? STICKY_DELETE_HEAD : undefined,
        },
    ]

    // Het bord toont ÁLLE huishoudens, niet alleen de gekozen statustab: de
    // kolommen zijn de statussen, dus filteren op één status zou één kolom
    // overhouden. De tabkeuze blijft wel bewaard voor de terugweg naar de tabel.
    const boardColumns = useMemo(
        () => groupItemsByStatus({
            // `adresses` en niet `visibleItems`: de statustabs horen hier niet
            // te filteren (de kolommen ZIJN de statussen). Het locatiefilter
            // hoort er wél in, dus dat staat er apart bij — precies de plek waar
            // een filter op alleen `visibleItems` het bord zou overslaan.
            items: filterByLocation(adresses, selectedLocationId),
            display: statusDisplay,
            // Langst wachtende bovenaan. Dat is de vraag waarmee een planner
            // naar dit scherm komt ("wie wacht het langst"), en zonder
            // sortering was de volgorde die van `Position` — voor haar
            // willekeurig. Puur weergave: er wordt niets geschreven.
            getSortValue: (item) => (item.Timestamp?.toMillis
                ? item.Timestamp.toMillis()
                : null),
        }),
        [adresses, statusDisplay, selectedLocationId],
    )

    /**
     * De velden onder de kop van een kaart.
     *
     * Uit dezelfde `columnConfig` als de tabel, dus wat de organisatie in het
     * overzicht uitzet, staat ook niet op de kaart. Straat is de kop en status
     * is de kolom; die twee hebben daarom geen `value`.
     *
     * @param {object} item - Het Adresses-document
     * @returns {Array<{key: string, label: string, value: React.ReactNode}>}
     */
    const boardCardFields = (item) => [
        ...visibleColumns
            .filter((column) => typeof columnConfig[column.key]?.value === 'function')
            .map((column) => ({
                key: column.key,
                label: column.label,
                value: columnConfig[column.key].value(item),
            })),
        ...extraTitles.map((titel) => ({
            key: `extra:${titel}`,
            label: titel.toUpperCase(),
            value: extraValue(item.ID, titel),
        })),
    ]

    // De tabel onder de agenda toont DEZELFDE kolommen als het tabeloverzicht,
    // uit dezelfde `columnConfig` — dus wat de organisatie bij Instellingen →
    // 'Kolommen in het overzicht van huishoudens' heeft gekozen, staat hier ook.
    // Twee kolomlijsten naast elkaar lopen gegarandeerd uiteen.
    // AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
    //
    // Wat er NIET in staat: de sleepgreep om rijen te herordenen (de volgorde
    // doet hier niets) en de knoppen Aanpassen/Verwijderen. In plaats daarvan
    // een eerste kolom met de greep waarmee je het huishouden de agenda in
    // sleept.
    const agendaColumns = [
        { key: 'drag', label: '', searchable: false },
        { key: 'star', label: '', searchable: false },
        ...visibleColumns.map((column) => ({
            key: column.key,
            label: column.label,
            ...columnConfig[column.key],
            cell: undefined,
        })),
        ...extraTitles.map((titel) => ({
            key: `extra:${titel}`,
            label: titel.toUpperCase(),
            searchable: false,
            sortable: true,
            sortAccessor: (item) => extraValue(item.ID, titel),
        })),
    ]

    /**
     * Eén rij van die tabel. De cellen komen uit dezelfde `columnConfig` als de
     * tabelweergave; alleen de eerste cel is anders.
     *
     * @param {object} item - Het huishouden
     * @param {boolean} canEdit - Of deze gebruiker bezoeken mag inplannen
     * @returns {JSX.Element}
     */
    const renderAgendaRow = (item, canEdit) => (
        <>
            <TableCell>
                {canEdit && (
                    <span className="household-agenda__grip" aria-hidden="true">
                        <DragIndicatorOutlinedIcon />
                    </span>
                )}
            </TableCell>
            <TableCell>
                <StarToggle starred={isStarred(item)} disabled={!canEdit} onToggle={(next) => starHandler(item, next)} />
            </TableCell>
            {visibleColumns.map((column) => (
                <Fragment key={column.key}>
                    {columnConfig[column.key].cell(item)}
                </Fragment>
            ))}
            {extraTitles.map((titel) => (
                <TableCell key={`extra:${titel}`}>
                    <p>{extraValue(item.ID, titel) || '—'}</p>
                </TableCell>
            ))}
        </>
    )

    /** @param {'table'|'board'|'agenda'} next */
    const viewHandler = (next) => {
        history.replace({ search: boardViewSearch(location.search, next) })
    }

    const filterBar = (
        <>
                {hasLocationFilter(locations) && (
                    <>
                        {/* Geen los label: de eerste optie ('Alle locaties') zegt
                            wat het is, en een actief filter krijgt een vulling. */}
                        <select
                            id="adress-overview-location"
                            aria-label="Locatie"
                            title="Locatie"
                            className={`table-filter${selectedLocationId ? ' table-filter--active' : ''}`}
                            value={selectedLocationId}
                            onChange={(e) => setSelectedLocationId(e.target.value)}
                        >
                            <option value="">Alle locaties</option>
                            {locationOptions.map((o) => (
                                <option key={o.value} value={o.value}>{o.label}</option>
                            ))}
                        </select>
                    </>
                )}
                {/* Het filter 'Label': één label tegelijk, '' = alle. */}
                {labelOptions.length > 0 && (
                    <>
                        <select
                            id="adress-overview-label"
                            aria-label="Label"
                            title="Label"
                            className={`table-filter${labelKey ? ' table-filter--active' : ''}`}
                            value={labelKey}
                            onChange={(e) => setLabelKey(e.target.value)}
                        >
                            <option value="">Alle labels</option>
                            {labelOptions.map((o) => (
                                <option key={o.id} value={o.id}>{o.label}</option>
                            ))}
                        </select>
                    </>
                )}
                {/* Het filter 'Met ster' geldt voor alle drie de weergaven, net
                    als het locatiefilter. */}
                <button
                    type="button"
                    className={`star-filter${starOnly ? ' star-filter--on' : ''}`}
                    aria-pressed={starOnly}
                    aria-label="Met ster"
                    title="Met ster"
                    onClick={() => setStarOnly((aan) => !aan)}
                >
                    <StarRoundedIcon fontSize="small" />
                </button>
                {/* Eén handeling om alle filters los te laten; alleen zichtbaar
                    als er iets actief is. */}
                {(selectedLocationId || labelKey || starOnly) && (
                    <button
                        type="button"
                        className="table-filter-clear"
                        onClick={() => { setSelectedLocationId(''); setLabelKey(''); setStarOnly(false) }}
                    >
                        Wis filters
                    </button>
                )}
            
        </>
    )

  return (
     <div className="main">
        <div className="main-container" >
            <PageHeader 
                heading={'Huishoudens'}
                description={`Het overzicht van alle huishoudens`}
                AI={false}
                // Ingang naar 'Huishoudens per status' waar de planner hem zoekt
                // (testronde 2026-10-13, R1-B2). AI-CONTEXT: See docs/features/huishoudens-status-per-periode.md
                actions={(
                    <button
                        type='button'
                        className='page-header-button page-header-button--outline'
                        onClick={() => history.push(`/${client}/housevisitsstatus`)}
                    >
                        Per periode bekijken
                    </button>
                )}
            />
            <AddressMatchesNotice />
            {/* De statustabs zijn op het bord overbodig: daar ís elke status
                een kolom, en filteren op één status zou er één overhouden. De
                keuze blijft in de url staan, zodat de tabel straks opent op
                dezelfde tab.

                Naast de agenda staan ze juist wél: daar kiest de planner
                dáármee welke stapel hij aan het inplannen is. */}
            {view !== BOARD_VIEW && (
                <SelectableGrid
                    items={options}
                    selectedId={selectedType}
                    getId={item => item.id}
                    getLabel={item => item.label}
                    onClick={selectStatus}
                />
            )}
            {/* Het locatiefilter staat BUITEN de `view !== BOARD_VIEW`-gate van de
                statustabs: het geldt voor alle drie de weergaven, ook het bord.
                Pas zichtbaar vanaf twee locaties — bij nul of één valt er niets
                te kiezen en leest een filter dat niets doet als een storing.
                AI-CONTEXT: See docs/features/huishouden-locaties.md */}
            {/* De filters horen bij alle drie de weergaven. In de tabel staan ze
                op de regel van het zoekveld (`searchBarStart`); de kolommen- en
                agendaweergave hebben geen zoekveld en houden een eigen regel. */}
            {view !== TABLE_VIEW && (
                <div className="adress-overview-locationbar">{filterBar}</div>
            )}
            {boardError && <p className="adress-overview-error">{boardError}</p>}
            <ReadOnlyGuard edit="addresses.edit">
                {(canEdit) => view === AGENDA_VIEW ? (
                    <>
                    {/* Dezelfde regel als de zoekbalk van de tabel, zodat de
                        schakelaar bij het wisselen niet verspringt. */}
                    <div className="adress-overview-viewbar">
                        <ViewSwitch value={view} onChange={viewHandler} showAgenda={householdPlanning} />
                    </div>
                    {/* FullCalendar leest initialView alleen bij mount, dus
                        wachten tot de instelling binnen is — anders opent de
                        agenda in een andere weergave dan ingesteld. */}
                    {settingsLoaded && (
                        <HouseholdAgendaView
                            // Het inplanscherm bestaat alleen op volledig
                            // scherm: verkleinen is terug naar de tabel.
                            onClose={() => viewHandler(TABLE_VIEW)}
                            items={visibleItems}
                            loaded={adressesLoaded}
                            selectedLocationId={selectedLocationId}
                            locationByAdressId={locationByAdressId}
                            adressStatusById={adressStatusById}
                            columns={agendaColumns}
                            renderRow={(item) => renderAgendaRow(item, canEdit)}
                            getLabel={getHouseholdLabel}
                            canEdit={canEdit}
                            userId={auth?.ID}
                            defaultAgendaView={defaultAgendaView}
                        />
                    )}
                    </>
                ) : (view === BOARD_VIEW ? (
                    <>
                    {/* Dezelfde regel als de zoekbalk van de tabel, zodat de
                        schakelaar bij het wisselen niet verspringt. */}
                    <div className="adress-overview-viewbar">
                        <ViewSwitch value={view} onChange={viewHandler} showAgenda={householdPlanning} />
                    </div>
                    {!adressesLoaded ? (
                        <p className="adress-overview-loading">Huishoudens worden opgehaald…</p>
                    ) : (
                    <StatusBoard
                        columns={boardColumns}
                        getItemKey={(item) => item.ID}
                        renderCard={(item) => (
                            <HouseholdBoardCard
                                title={getHouseholdLabel(item)}
                                to={`/${client}/adressdetails/${item.ID}`}
                                fields={boardCardFields(item)}
                            />
                        )}
                        onMove={boardMoveHandler}
                        canDrag={canEdit}
                        emptyLabel="Sleep hier een huishouden naartoe"
                    />
                    )}
                    </>
                ) : (
                    <Table
                        columns={tableColumns}
                        items={visibleItems}
                        draggable
                        droppableId="adresses"
                        onDragEnd={handleDragEnd}
                        emptyMessage="Nog geen huishoudens gevonden."
                        searchPlaceholder="Zoeken in alle gegevens"
                        searchBarStart={filterBar}
                        searchAccessor={householdSearchValue}
                        searchSummary={searchSummary}
                        searchBarEnd={(
                            <>
                                {/* Alleen in de tabel: de brede listener op de
                                    gegevensregels die de export nodig heeft,
                                    staat alleen daar aan. */}
                                <ViewSwitch value={view} onChange={viewHandler} showAgenda={householdPlanning} />
                                <ExportBar
                                    pageHeader='Huishoudens exporteren'
                                    items={exportItems}
                                    itemsLabel='Huishoudens'
                                    groups={exportGroups}
                                    groupsLabel='Statussen'
                                    groupNoun='status'
                                    onOpen={() => {
                                        setExportArmed(true)
                                        // Een melding van de vorige poging
                                        // ('de gegevens worden nog opgehaald')
                                        // blijft anders staan tot een volgende
                                        // export lukt.
                                        setExportMessage('')
                                    }}
                                    onExport={exportHandler}
                                    emptyMessage='Er zijn geen huishoudens om te exporteren.'
                                />
                            </>
                        )}
                        onSearchActive={() => setSearchArmed(true)}
                        getItemKey={(item) => item.ID}
                        renderRow={(item, index, { searchTerm } = {}) => (
                            <>
                                <TableDragHandleCell>
                                    <DragIndicatorOutlinedIcon />
                                </TableDragHandleCell>
                                <TableCell>
                                    <StarToggle starred={isStarred(item)} disabled={!canEdit} onToggle={(next) => starHandler(item, next)} />
                                </TableCell>
                                {/* Uit dezelfde lijst als de koprij, dus altijd
                                    evenveel cellen in dezelfde volgorde. */}
                                {visibleColumns.map((column) => (
                                    <Fragment key={column.key}>
                                        {columnConfig[column.key].cell(item, searchTerm)}
                                    </Fragment>
                                ))}
                                {extraTitles.map((titel) => (
                                    <TableCell key={`extra:${titel}`}>
                                        {/* Het em-streepje is de weergave van
                                            'niet ingevuld'; de sorteersleutel
                                            hierboven gebruikt bewust ''. */}
                                        <p>{extraValue(item.ID, titel) || '—'}</p>
                                    </TableCell>
                                ))}
                                <TableCell>
                                    <EditOutlinedIcon className='table-delete-icon' onClick={() => history.push(`/${client}/adressdetails/${item.ID}`)}/>
                                </TableCell>
                                <TableCell className={stickyDeleteColumn ? STICKY_DELETE_CELL : undefined}>
                                    {canEdit && (
                                        <DeleteOutlinedIcon className='table-delete-icon' data-docid={item.docid} data-deletename={getHouseholdLabel(item)} onClick={deleteModalHandler} />
                                    )}
                                </TableCell>
                            </>
                        )}
                        addRow={canEdit ? {
                            toolTipContent: 'Adres toevoegen',
                            onClick: addAdress,
                        } : undefined}
                    />
                ))}
            </ReadOnlyGuard>
            {exportMessage && <p className='dashboard-export-message' role='alert'>{exportMessage}</p>}
            <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} deleteItem={deleteAdress} deleteName={deleteName} softDelete linkedNote="De afspraken, gegevens, notities, materialen en contactmomenten van dit huishouden gaan mee." />
        </div>
    </div>
  )
}

export default Overview
